import { Booking } from "../../types/booking";

type BookingPayload = Booking | Booking[];

interface AddBookingAction {
  type: 'ADD_BOOKING';
  payload: BookingPayload;
}

interface UpdateBookingAction {
  type: 'UPDATE_BOOKING';
  payload: Booking;
}

interface DeleteBookingAction {
  type: 'DELETE_BOOKING';
  payload: string;
}

export type BookingActionTypes =
  | AddBookingAction
  | UpdateBookingAction
  | DeleteBookingAction;

export const addBooking = (bookingId: BookingPayload): AddBookingAction => ({
  type: 'ADD_BOOKING',
  payload: bookingId,
});

export const updateBooking = (booking: Booking): UpdateBookingAction => ({
  type: 'UPDATE_BOOKING',
  payload: booking,
});

export const deleteBooking = (bookingId: string): DeleteBookingAction => ({
  type: 'DELETE_BOOKING',
  payload: bookingId,
});
